import type { DecompositionNode } from 'api/data/projects/types';

import type { DecompositionTreePage } from '../types';

export function buildTreePage(nodes: DecompositionNode[], offset: number, limit: number): DecompositionTreePage {
  const hasMore = nodes.length > limit;
  return {
    items: hasMore ? nodes.slice(0, limit) : nodes,
    hasMore,
    nextOffset: offset + limit
  };
}
